package game.entity

import game.Game
import game.Room

class TipMessage: Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("tip-message")
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.showDialog(params)

        return false
    }
}